import { ProjectExtended } from "@nova/schemas"

type ProjectFilterOption = {
    id: string
    title: string
    shortTitle: string
    filter: (p: { updatedAt: ProjectExtended["updatedAt"] }) => boolean
}
const DAY_MS = 1000 * 60 * 60 * 24
const isTimestampWithinDays = (timestamp: string, days: number) =>
    Date.now() - new Date(timestamp).getTime() <= days * DAY_MS
export const projectFilterOptions = [
    {
        id: "1day",
        title: "Last Day",
        shortTitle: "1 Day",
        filter: ({ updatedAt }) => isTimestampWithinDays(updatedAt, 1),
    },
    {
        id: "7days",
        title: "Last 7 Days",
        shortTitle: "7 Days",
        filter: ({ updatedAt }) => isTimestampWithinDays(updatedAt, 7),
    },
    {
        id: "30days",
        title: "Last 30 Days",
        shortTitle: "30 Days",
        filter: ({ updatedAt }) => isTimestampWithinDays(updatedAt, 30),
    },
    {
        id: "60days",
        title: "Last 60 Days",
        shortTitle: "60 Days",
        filter: ({ updatedAt }) => isTimestampWithinDays(updatedAt, 60),
    },
    {
        id: "6months",
        title: "Last 6 Months",
        shortTitle: "6 Months",
        filter: ({ updatedAt }) => isTimestampWithinDays(updatedAt, 182),
    },
    {
        id: "1year",
        title: "Last Year",
        shortTitle: "1 Year",
        filter: ({ updatedAt }) => isTimestampWithinDays(updatedAt, 365),
    },
    {
        id: "alltime",
        title: "All Time",
        shortTitle: "All Time",
        filter: () => true,
    },
] as const satisfies ProjectFilterOption[]

export type ProjectFilterOptionId = (typeof projectFilterOptions)[number]["id"]

export const getProjectFilterOptionById = (id: ProjectFilterOptionId) =>
    projectFilterOptions.find((option) => option.id === id)!
